import React, { useMemo, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Layout,
  Checkbox,
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Radio,
  Collapse,
  AutoComplete,
  Breadcrumb
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import {
  PlusSquareFilled,
  MinusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import verifybtn from "../../image/verifybtn.png";
import PhoneInput from "react-phone-input-2";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
// import PermissionPanelStep from "./PermissionPanelStep";
import PermissionPanelStep from "../../authentication/steps/PermissionPanelStep";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const { Panel } = Collapse;
const AddSuperUserRole = () => {
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const companyAdmin = authUserData()?.company_role ? authUserData()?.company_role: null;
  const vendorAdmin = authUserData()?.vendor_role ? authUserData()?.vendor_role: null;
  const superAdmin = authUserData()?.role ? authUserData()?.role[0].name: null;
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { id } = useParams();
  const groupId = id ? atob(id) : null;
  const [arrow, setArrow] = useState("Show");
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];

  const onChange = (key) => {
    console.log(key);
  };

  const [permissions, setPermissions] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedAppLabel, setSelectedAppLabel] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  let initialState;

  initialState = {
    group_name: "",
    permissions: [],
  };
  // }else{
  //   const
  // }
  const [state, setState] = useState(initialState);
  const [familyName, setFamilyName] = useState([]);
  const { Option } = AutoComplete;

  const fetchPermissions = async () => {
    try {
      const response = await getRequest(`create-group-permissions/${groupId}/`);

      if (response.data.success) {
        // setPermissions(data.data);
        setState({
          group_name: response.data.response.group_name,
          permissions: response.data.response.permissions.map(
            (permission) => permission.id
          ),
        });
        // {
        //   "group_name":response.data.response.group_name,
        //   "role_family":response.data.response.role_family,
        // }
        formRef.current.setFieldsValue({
          ...state,
          group_name: response.data.response.group_name,
        });
      } else {
        console.error("Error fetching permissions:");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchPermissions();
    }
  }, [groupId]);

  useEffect(() => {
    PRApprovalHierarchyGetById();
    //getFamilyName();
  }, [selectedModel, selectedAppLabel]);
  const PRApprovalHierarchyGetById = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(`list-permission/?group_name=${superAdmin}`);

      if (apiResponse.status) {
            setPermissions(apiResponse.data.data);
      } else {
            ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
        setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getFamilyName = async (data) => {
    await getRequest("role-family/?no_pagination=True", data).then(
      (response) => {
        setFamilyName(response.data.data);
      }
    );
  };
  const handleFamilySelectChange = async (value) => {
    setState({ ...state, role_family: value });
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
  };

  const getUniqueObjectsByModelName = (permissions) => {
    const uniqueObjects = [];
    const modelNames = new Set();

    permissions.forEach((permission) => {
      if (!modelNames.has(permission.model)) {
        modelNames.add(permission.model);
        uniqueObjects.push(permission);
      }
    });

    return uniqueObjects;
  };
  const uniquePermissions = useMemo(
    () => getUniqueObjectsByModelName(permissions),
    [permissions]
  );

  // const uniqueModelNames = useMemo(() => getUniqueModelNames(permissions), [permissions]);
  // useEffect(() => {
  //   PRApprovalHierarchyGetById();
  // }, [reload, state]);
  const handleSubmit = async () => {
    setBtnLoading(true);

    let payload;
    payload = {
        ...state,
    };

    try {
      let apiResponse;

      if (groupId === null) {
        apiResponse = await postRequest("create-group-permissions/", payload);
      } else {
        apiResponse = await patchRequest(
          `create-group-permissions/${groupId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          groupId === null
            ? t("Group added successfully")
            : t("Group updated succesfully")
        );
        updateSubscriptionStatus();

        navigate("/superuser-role");
      } else {
        ErrorNotificationMsg(t("Error in group"));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };


  return (
    <>
    <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                {groupId ? (
                <h3>Edit User Group</h3>
              ) : (
                <h3>Add User Group</h3>
              )}
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
     {groupId ? (
                <Breadcrumb.Item>Edit User Group</Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item>Add User Group</Breadcrumb.Item>
              )}
                  
                </Breadcrumb>
                </div>
            
              
            </div>
          </div>
          <Content className="stepscontentwrap">
           
              <div className="stepsContent">
                <div className="formwrapper">
                   <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                      <Form.Item>
                        <InputField
                          name="group_name"
                          label={t("Functional Designation")}
                          placeholder={t("Enter Functional Designation")}
                          rules={t("Enter valid designation")}
                          // pattern={"^[a-zA-Z ]+$"}
                          pattern={"^[a-zA-Z ()]+$"}
                          handleInputChange={handleInputChange}
                          max={50}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div className="sectiontitle">Permissions</div>

                  <div style={{ paddingRight: "5px" }}>
                    {/* <Collapse defaultActiveKey={['1']} onChange={onChange}> */}
                    {/* {uniqueModelNames.map((modelName) => ( */}
                    {uniquePermissions.map((permission, index) => {
                      return (
                        <>
                          {groupId !== null && groupId !== undefined ? (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              groupId={groupId}
                              state={state}
                              setState={setState}
                              index = {index}
                            />
                          ) : (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              state={state}
                              setState={setState}
                            />
                          )}
                        </>
                      );
                    })}
                    {/* <PermissionPanelStep appLabel={63} modelName="employee" state={state} setState={setState} /> */}
                    {/* <PermissionPanelStep appLabel={64} modelName="companydocument" state={state} setState={setState} />
                    <PermissionPanelStep appLabel={64} modelName="companydocument" state={state} setState={setState} /> */}
                    {/* <PermissionPanelStep appLabel={9} modelName="group" /> */}

                    {/* </Collapse> */}
                  </div>
                  </Form> 
                </div>
              </div>
              <div className="stepsFooter">
                <Button
                  cursor="pointer"
                  type="secondary"
                  className="primary"
                  onClick={() => navigate("/superuser-role")}
                >
                  Previous
                </Button>
                <Button
                  cursor="pointer"
                  type="primary"
                  className="primary"
                  htmlType="Submit"
                  label={t("save")}
                  loading={btnLoading}
                  // onClick={()=>handleSubmit()}
                >
                  Save
                </Button>
              </div>
          
          </Content>
     
    </>
  );
};

export default AddSuperUserRole;
